<template>
  <div class="fundsInterests">
    <vxe-toolbar>
      <template v-slot:buttons>
        <vxe-button
          type="primary"
          icon="el-icon-download"
          class="vxe-btn-primary"
          @click="handleExport()"
          >{{ $t('functionBtn.export') }}</vxe-button
        >
      </template>
    </vxe-toolbar>
    <vxe-grid
      border
      show-overflow
      resizable
      ref="table"
      class="vxe-table-element"
      size="mini"
      align="left"
      :auto-resize="true"
      :data="tableData"
      :columns="columnList"
      :sort-config="{ defaultSort: { field: 'serializationJsonData.date', order: 'asc' } }"
      show-footer
      :footer-method="footerMethod"
      column-min-width="120"
      :max-height="tableHeight"
    >
    </vxe-grid>
  </div>
</template>
<script>
  import API from '@/api/capitalCenter/settle';
  import { mapState } from 'vuex';
  import fullScreenDialog from '@/common/mixins/fullScreenDialog.js';
  import XEUtils from 'xe-utils';
  import baseUrl from '@/common/config';
  export default {
    mixins: [fullScreenDialog],
    name: 'fundsInterests',
    props: ['settleNo'],
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      token() {
        return {
          access_token: this.userInfo.access_token,
          companyCode: this.userInfo.companyCode,
          companyName: this.userInfo.companyName,
          departmentCode: this.userInfo.departmentCode,
          departmentName: this.userInfo.departmentName,
          tenantCode: this.userInfo.tenantCode,
        };
      },
      columnList() {
        return [
          { type: 'seq', title: this.$t('table.index'), width: 60, fixed: 'left' }, // 序号
          {
            field: 'serializationJsonData.date',
            title: this.$t('batchAdd.fundsInterests.date'),
            sortable: true,
          }, // 日期
          {
            // 付款金额
            field: 'serializationJsonData.payAmount',
            title: this.$t('batchAdd.fundsInterests.payAmount'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(row.serializationJsonData.payAmount)}
                  </span>,
                ];
              },
            },
          },
          {
            // 付款折合吨数
            field: 'serializationJsonData.payTon',
            title: this.$t('batchAdd.fundsInterests.payTon'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(
                      row.serializationJsonData.payTon,
                      this.$globalVar.qPoint
                    )}
                  </span>,
                ];
              },
            },
          },
          {
            // 收款金额
            field: 'serializationJsonData.collectAmount',
            title: this.$t('batchAdd.fundsInterests.collectAmount'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(row.serializationJsonData.collectAmount)}
                  </span>,
                ];
              },
            },
          },
          {
            // 收款折合吨数
            field: 'serializationJsonData.collectTon',
            title: this.$t('batchAdd.fundsInterests.collectTon'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(
                      row.serializationJsonData.collectTon,
                      this.$globalVar.qPoint
                    )}
                  </span>,
                ];
              },
            },
          },
          {
            // 合同均价
            field: 'serializationJsonData.contractUnitPrice',
            title: this.$t('batchAdd.fundsInterests.contractUnitPrice'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(
                      row.serializationJsonData.contractUnitPrice,
                      this.$globalVar.pPoint
                    )}
                  </span>,
                ];
              },
            },
          },
          {
            // 差额
            field: 'serializationJsonData.gap',
            title: this.$t('batchAdd.fundsInterests.gap'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>{this.$baseRequest.formatTableColumn(row.serializationJsonData.gap)}</span>,
                ];
              },
            },
          },
          {
            // 资金利息
            field: 'serializationJsonData.fundInterest',
            title: this.$t('batchAdd.fundsInterests.fundInterest'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(row.serializationJsonData.fundInterest)}
                  </span>,
                ];
              },
            },
          },
        ];
      },
    },
    data() {
      return {
        tableData: [],
      };
    },
    methods: {
      handleExport() {
        // 导出
        if (this.tableData.length == 0) {
          return this.$message({
            showClose: true,
            message: this.$t('message.noExport'),
            type: 'error',
          });
        }
        const params = XEUtils.serialize({ settleNo: this.settleNo });
        window.location.href = `${baseUrl}${API.EXPORT_FUNDINTEREST}?${params}&access_token=${this.token.access_token}`;
      },
      footerMethod({ columns, data }) {
        let returnProps = [
          'serializationJsonData.payAmount',
          'serializationJsonData.payTon',
          'serializationJsonData.collectAmount',
          'serializationJsonData.collectTon',
          'serializationJsonData.gap',
          'serializationJsonData.fundInterest',
        ];
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return this.$t('xTable.total');
            }
            if (returnProps.includes(column.property)) {
              let subtrahend = 0;
              data.map((item) => {
                subtrahend = this.$cal.calCommon(
                  item.serializationJsonData[column.property.replace('serializationJsonData.', '')],
                  subtrahend,
                  '+'
                );
              });
              let point;
              if (column.property.indexOf('Ton') != -1) {
                point = this.$globalVar.qPoint;
              }
              return this.$baseRequest.formatTableColumn(subtrahend, point);
            }
            return null;
          }),
        ];
      },
    },
  };
</script>
